// Mint-TMS-Phone · khung 1 "Điều độ hôm nay" trên điện thoại (390). Dữ liệu mẫu đúng dòng + thứ tự của board (T0, FD, asgOpts).
import { TRIP_STEPS } from './types';

export type PhoneRisk = 'ok' | 'late' | 'gấp' | 'done';
export type PhoneFilter = 'all' | 'run' | 'risk' | 'none';

/** Một thẻ chuyến của board: step = số bước đã xong, -1 = chưa gán xe. */
export interface PhoneTrip {
  id: string;
  truck: string;
  desc: string;
  step: number;
  due: string;
  risk: PhoneRisk;
  flag?: string;
}

export const PHONE_TRIPS: readonly PhoneTrip[] = [
  { id: 'TR-2610-0322', truck: '— chưa gán', desc: 'HANA-SE-2610-0145 · 1×40HC · Sóng Thần → Cát Lái', step: -1, due: '06:00 mai', risk: 'gấp', flag: 'gấp' },
  { id: 'TR-2610-0316', truck: '51D-221.09', desc: 'Ngô Văn Thắng · 1×20DC · giao kho', step: 5, due: '14:00', risk: 'late', flag: 'trễ 25′' },
  { id: 'TR-2610-0311', truck: '51C-628.14', desc: 'Nguyễn Văn Công · 1×40HC · Cát Lái', step: 4, due: '15:00', risk: 'ok' },
  { id: 'TR-2610-0312', truck: '51D-140.77', desc: 'Lê Minh Định · 1×40HC · Cát Lái', step: 2, due: '15:00', risk: 'ok' },
  { id: 'TR-2610-0318', truck: '51C-377.40', desc: 'Phạm Minh Tuấn · 2×20DC · Cát Lái', step: 1, due: '19:00', risk: 'ok', flag: 'gấp < 4h' },
  { id: 'TR-2610-0320', truck: 'Nhà xe Quỳnh Vy', desc: '51C-771.20 · 1×40HC · Cát Lái', step: 2, due: '21:00', risk: 'ok' },
  { id: 'TR-2610-0319', truck: '51D-512.83', desc: 'Võ Kim Nguyên · 1×40HC', step: 6, due: 'Xong 10:42', risk: 'done' },
];

export const PHONE_FILTERS: ReadonlyArray<{ key: PhoneFilter; label: string; test: (t: PhoneTrip) => boolean }> = [
  { key: 'all', label: 'Tất cả', test: () => true },
  { key: 'run', label: 'Chạy', test: (t) => t.step > 0 && t.step < 6 },
  { key: 'risk', label: 'Rủi ro', test: (t) => t.risk === 'late' || t.risk === 'gấp' },
  { key: 'none', label: 'Chưa gán', test: (t) => t.step < 0 },
];

export const phoneCounts = (trips: readonly PhoneTrip[]): Record<PhoneFilter, number> =>
  Object.fromEntries(PHONE_FILTERS.map((f) => [f.key, trips.filter(f.test).length])) as Record<PhoneFilter, number>;

export const phoneFilter = (trips: readonly PhoneTrip[], k: PhoneFilter): PhoneTrip[] => trips.filter((PHONE_FILTERS.find((f) => f.key === k) ?? PHONE_FILTERS[0]!).test);

/** Màu từng đoạn trong thanh 7 bước: 'done' đã qua · 'cur' bước hiện tại · 'next' chưa tới. */
export function phoneSteps(t: PhoneTrip): Array<'done' | 'cur' | 'cur-late' | 'cur-end' | 'next'> {
  return TRIP_STEPS.map((_, j) => (j < t.step ? 'done' : j === t.step ? (t.step === 6 ? 'cur-end' : t.risk === 'late' ? 'cur-late' : 'cur') : 'next'));
}

/** Dòng trạng thái + việc chính của thẻ (chưa gán xe → "Gán xe", còn lại "Đổi xe"). */
export function phoneStatus(t: PhoneTrip, assigned: boolean): { text: string; unassigned: boolean; action: 'Gán xe' | 'Đổi xe' } {
  const un = t.step < 0 && !assigned;
  return { text: un ? 'Chưa gán xe · TVA hạn 16:00' : t.step === 6 ? 'Xong' : `Đang: ${TRIP_STEPS[Math.max(t.step, 0)]}`, unassigned: un, action: un ? 'Gán xe' : 'Đổi xe' };
}

export const ASSIGN_OPTS: ReadonlyArray<{ k: string; v: string; kind: 'XN' | 'NX' }> = [
  { k: '51D-512.83', v: 'Võ Kim Nguyên · trống · cách 6 km', kind: 'XN' },
  { k: '51C-628.14', v: 'rảnh sau 15:00 · ghép chuyến', kind: 'XN' },
  { k: 'Nhà xe Quỳnh Vy', v: '2 xe trống · đánh giá 4,6', kind: 'NX' },
  { k: 'Nhà xe Đức Quân Minh', v: '1 xe trống', kind: 'NX' },
];
